module.exports = __webpack_public_path__ + "img/swhz.0aca1720.png";